import { useTranslation } from 'react-i18next';

export function NotFoundPage(): JSX.Element {
  const { t } = useTranslation('common');
  return (
    <main className="flex min-h-screen items-center justify-center bg-background p-8">
      <h1 className="text-2xl font-semibold text-foreground">
        {t('not_found')}
      </h1>
    </main>
  );
}

export default NotFoundPage;
